import React from 'react';
import { SubHeading } from '../../components';

import { images } from '../../constants';
import './Header.css';

const Header = () => (
  <div className='app__header app__wrapper section__padding' id='home'>
    <div className='app__wrapper_info'>
      <SubHeading title="Think it, We bring it to life."/>
      <h1 className='app__header-h1'>Outrageous designs that works.</h1>
      <p className='p__opensans' style={{ margin:'2rem 0'}}>
        Creating comtemporary UI & UX designs that is aimed at providing visual and sensory guides to users and product consumers.</p>
      <p className='p__opensans' style={{ margin:'2rem 0'}}>
      We build relationships. This is the heart of our company because we want to be a true partner throughout your entire building process.</p>
    </div>


  </div>
);

export default Header;
